import { useQuery } from '@tanstack/react-query';
import type { ProcurementRequest } from '@contracts/procurement';
import {
  fetchProcurementOrders,
  fetchProcurementSummary,
} from '@/features/procurement/services/procurementService';
import { useProcurementFilters } from '@/features/procurement/procurementContext';

/** Arma el request del dominio desde los filtros del contexto. */
function useProcurementRequest(): ProcurementRequest {
  const { period, companies, scope } = useProcurementFilters();
  return { period: period ?? undefined, companies, scope };
}

/** KPIs del tablero de compras. */
export function useProcurementSummary() {
  const req = useProcurementRequest();
  return useQuery({
    queryKey: ['procurement-summary', req],
    queryFn: () => fetchProcurementSummary(req),
  });
}

/** Lista de órdenes de compra (tablas + drill-down). */
export function useProcurementOrders() {
  const req = useProcurementRequest();
  return useQuery({
    queryKey: ['procurement-orders', req],
    queryFn: () => fetchProcurementOrders(req),
  });
}
